import { FilterRuleDTO } from "./filterRuleDTO";

export class FilterProtocolDTO {

    public id!: number;
    public sequenceNo!: number;
    public filterRules!: FilterRuleDTO[];
    public filterOr!: boolean;

    constructor(){
        this.filterRules = new Array();
    }
}